/** Tailwind needs literal class names. Must match the tool page container (docs/codebase-map.md 'Site shell'). */
export type ToolContentWidth = '5xl' | '6xl' | '7xl' | '1600';
export const TOOL_CONTENT_WIDTH: Record<ToolContentWidth, string> = {
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
  '1600': 'max-w-[1600px]',
};
